<template>
  <GradientCard class="calculator" inner-class="calculator__inner">
    <div class="calculator__header">
      <div class="calculator__title">
        <span>{{ $t('calculator.title') }}:</span>
      </div>
      <div class="calculator__stock">
        <span>{{ $t('transfer.available') }}</span>
        <span class="number">{{ rbxAmount }} R$</span>
      </div>
    </div>

    <div class="calculator__data">
      <div class="calculator__item">
        <span class="calculator__label">{{ $t('calculator.youPay') }}</span>
        <Input
          :value="rubTotal"
          type="number"
          size="md"
          icon-text="₽"
          :hide-hint="true"
          @input="rubTotalChangeableHandler"
        />
      </div>
      <div class="calculator__item">
        <span class="calculator__label">{{ $t('calculator.youGet') }}</span>
        <Input
          :value="robux"
          type="number"
          size="md"
          icon-text="R$"
          :hide-hint="true"
          @input="amountHandlerWithSlider"
        />
      </div>
    </div>
    <RangeInput :value="robux" type="number" @input="amountHandlerWithSlider" />
  </GradientCard>
</template>

<script>
import RangeInput from '@/components/RangeInput/RangeInput.vue'
import GradientCard from '@/components/GradientCard/GradientCard.vue'
import Input from '@/components/Base/Input/Input.vue'
import { mapState } from 'vuex'

import Purchase from '@/enums/Purchase'

export default {
  name: 'Calculator',
  components: { Input, GradientCard, RangeInput },

  data() {
    return {
      robux: Purchase.MIN_TO_BUY
    }
  },
  computed: {
    ...mapState(['methodRates', 'currency']),
    rate() {
      return this.methodRates.transfer_rate[this.currency]
    },
    rbxAmount() {
      return this.$store.state.rbxAmountStock.toLocaleString('ru-RU')
    },
    rubTotal() {
      if (!this.robux) return 0
      return Math.ceil(Number(this.robux) * this.rate).toFixed(0)
    }
  },

  methods: {
    rubTotalChangeableHandler(data) {
      data = data?.toString().replace(/\D/g, '')

      this.robux = Math.floor(+data / this.rate).toFixed(0)
      this.$emit('input', this.robux)
    },

    amountHandlerWithSlider(data) {
      data = data?.toString().replace(/\D/g, '')
      this.robux = +data
      this.$emit('input', this.robux)
    }
  }
}
</script>

<style lang="scss">
@import './calculator';
</style>
